import React from "react";
import { LiferayService } from "../../../common/services/liferay";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";

export const StockReportContext = React.createContext();

export const ACTIONS = {
  SET_ACTION_LIST: "SET_ACTION_LIST",
  SET_ERROR: "SET_ERROR",
  SET_ACTION_REPORTS: "SET_ACTION_REPORTS",
  SET_ACTION_REPORTS_RESPONSE: "SET_ACTION_REPORTS_RESPONSE",
};

const initialState = {
  actionList: null,
  errorFetch: null,
  actionReports: null,
  actionReportsResponse: null,
};

const StockReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_ACTION_LIST: {
      return {
        ...state,
        actionList: action.payload,
      };
    }
    case ACTIONS.SET_ACTION_REPORTS: {
      return {
        ...state,
        actionReports: action.payload,
      };
    }
    case ACTIONS.SET_ACTION_REPORTS_RESPONSE: {
      return {
        ...state,
        actionReportsResponse: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

function StockReportContextProvider({ children }) {
  const properties = React.useContext(ApplicationPropertiesContext);
  const [state, dispatch] = React.useReducer(StockReportReducer, initialState);

  React.useEffect(() => {
    if (state.actionReports) {
      LiferayService.setActionReports(properties.base_url_api, state.actionReports)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_ACTION_REPORTS_RESPONSE,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.actionReports]);

  React.useEffect(() => {
    LiferayService.getActionsList(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_ACTION_LIST,
        });
      })
      .catch((error) => {
        dispatch({
          payload: error,
          type: ACTIONS.SET_ERROR,
        });
      });
  },[])

  return (
    <StockReportContext.Provider value={[state, dispatch]}>
      {children}
    </StockReportContext.Provider>
  );
}

export default StockReportContextProvider;
